
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    activator_url:'https://activator.kgrid.org/',
    patientPanel:{},
    featureSamplePanel:{},
    groupDisplaySchema:{},
    fullRecommendationList:[],
    patientData:[],
    currentPatientIndex:-1,
    currentPatientDemographics:{age:0,race:'other',gender:'other'},
    paths:{
     "default_act_url_index":  process.env.VUE_APP_ACTIVATOR_URL_INDEX,
     "activator_urls":["https://activator.kgrid.org/", "http://localhost:8080/"]
   },
  },
  mutations: {
    setFullList(state, list){
      state.fullRecommendationList = JSON.parse(JSON.stringify(list))
    },
    setPatientData(state, data){
      state.patientData = JSON.parse(JSON.stringify(data))
    },
    setFeatureSamplePanel (state, panel) {
      state.featureSamplePanel = panel
    },
    setGroupDisplaySchema (state, schema) {
      state.groupDisplaySchema = JSON.parse(JSON.stringify(schema))
    },
    setCurrentPatientIndex (state, index) {
      state.currentPatientIndex = index
      if(index!=-1){
        state.currentPatientDemographics.age= state.patientData[index].patient.features.age
        state.currentPatientDemographics.race= state.patientData[index].patient.features.race
        state.currentPatientDemographics.gender= state.patientData[index].patient.features.gender
      } else {
        state.currentPatientDemographics.age= 0
        state.currentPatientDemographics.race= "other"
        state.currentPatientDemographics.gender= "other"
      }
    },
    setactivatorurls(state,urls){
      if(urls.length>0){
        state.paths.activator_urls = []
        urls.forEach(function(e){
            state.paths.activator_urls.push(e)
          }
        )
      }
    },
    setdefaultactivatorurlindex(state, i){
      state.paths.default_act_url_index = i
    },
    setcurrentactivatorurl(state,url){
      state.activator_url = url
    }
  },
  getters: {
    getcurrentactivatorurl: state =>{
      return state.activator_url
    },
    getcurrentPatientData: state=>{
      if(state.currentPatientIndex!=-1){
        return state.patientData[state.currentPatientIndex]
      } else {
        return {}
      }
    },
    getPatientPanel: state=>index=>{
      var panel = null
      if(index < state.patientData.length){
        var data = state. patientData[index]
        panel= JSON.parse(JSON.stringify(state.featureSamplePanel))
        panel.patient.features.forEach(function(e){
          var id = e.name
          e.value=data.patient.features[id]
        })
      }
      return panel;
    },
    getFeatureSamplePanel: state=>{
      return state.featureSamplePanel;
    },
    getGroupDisplaySchema: state=>{
      return state.groupDisplaySchema;
    },
    getCurrentPatientID: state=>{
      if(state.currentPatientIndex==-1 | state.patientData.length==0){
        return null
      } else {
        return state.patientData[state.currentPatientIndex].patient.id
      }
    },
    getCurrentPatientIndex: state=>{
      return state.currentPatientIndex
    },
    getPatientData:state=>{
      if(state.patientData.length>0){
        return state.patientData
      } else {
        return []
      }
    },
    getCurrentPatientDemographics: state=>{
      return state.currentPatientDemographics
    },
    getactivatorurls:state=>{
       return state.paths.activator_urls
     },
     getdefaultactivatorurlindex:state=>{
       var i = state.paths.default_act_url_index
       return i
     },
  },
  actions: {

  },
});
